import { useEffect, memo, useState, useMemo } from "react";
import { Button, Flex, Space, Divider, Input, Switch, theme, Card, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useItemsScreenContext } from "pages/items";
import { useAppContext } from "context/app";
const { useToken } = theme;

const ItemSelectedMenuBar = () => {
    const { token } = useToken();
    const { selectedItems, setSelectedItems, currentFolder } = useItemsScreenContext();
    const { showModal } = useAppContext();

    const disableUpdateQuantity = useMemo(() => selectedItems.some((item) => item.entity_type === "folder"), [selectedItems]);

    const disableClone = useMemo(() => selectedItems.some((item) => item.has_variants), [selectedItems]);

    if (selectedItems.length <= 0) return null;

    const options = [
        {
            key: "add_tag",
            label: <div>Add tags</div>,
        },
        {
            key: "remove_tag",
            label: <div>Remove tags</div>,
        },
    ];

    const menuClick = ({ item, key, keyPath, domEvent }) => {
        console.log({ item, key, keyPath });

        switch (key) {
            case "add_tag":
                showModal("setTag", {
                    items: selectedItems,
                    folderId: currentFolder,
                    type: "Add",
                });
                break;
            case "remove_tag":
                showModal("setTag", {
                    items: selectedItems,
                    folderId: currentFolder,
                    type: "Remove",
                });
                break;
            default:
                break;
        }
    };

    return (
        <div style={{ padding: token.padding, backgroundColor: token.colorBgContainer, marginBottom: token.marginLG, borderRadius: token.borderRadius, display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
                {selectedItems.length} Items selected
                <Button type="link" onClick={(e) => setSelectedItems([])}>
                    Clear
                </Button>
            </div>
            <div>
                <Space style={{ color: token.colorPrimary }}>
                    {/* <Button type="link">Edit</Button> */}
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("updateMultiQuantity", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                        disabled={disableUpdateQuantity}
                    >
                        Update Quantity
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            const checkHasFolder = selectedItems.some((item) => item.entity_type === "folder");
                            if (checkHasFolder) {
                                showModal("moveFolders", {
                                    items: selectedItems,
                                    folderId: currentFolder,
                                });
                            } else {
                                showModal("moveMultiQuantity", {
                                    items: selectedItems,
                                    folderId: currentFolder,
                                });
                            }
                        }}
                    >
                        Move
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("export", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                    >
                        Export
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("createLabel", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                    >
                        Create Label
                    </Button>
                    <Dropdown
                        menu={{
                            items: options,
                            onClick: menuClick,
                        }}
                    >
                        <Button type="link">
                            <span>Tags</span>
                            <DownOutlined style={{ marginTop: "4px" }} />
                        </Button>
                    </Dropdown>
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("alert", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                        disabled={disableUpdateQuantity}
                    >
                        Alert
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("clone", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                        disabled={disableClone}
                    >
                        Clone
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            showModal("delete", {
                                items: selectedItems,
                                folderId: currentFolder,
                            });
                        }}
                    >
                        Delete
                    </Button>
                </Space>
            </div>
        </div>
    );
};

export default memo(ItemSelectedMenuBar);
